import React from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

import { formatNull } from '../../Utils/GlobalUtils';

import InfoMessage from '../InfoMessage';
import NewsBlock from '../NewsBlock';
import LoadingBlock from '../LoadingBlock';
import WarningPanel from '../WarningPanel';

import styles from '../../styles/Home.module.css';

import { ReactComponent as ArrowRight } from '../../icons/chevron-right.svg';
import IconContainer from '../IconContainer';

const WorkerHome = ({ userId }) => {
    const navigate = useNavigate();

    const [formInfo, setFormInfo] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);
        setWarning('');

        axios.get(`/api/get-home-admin-info?user_id=${userId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
        })
        .then((response) => {
            setFormInfo(response.data);
        })
        .catch((error) => {
            console.error(error);
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, userId]);

    const STORAGE_KEY = 'proposedcasesworker_filters';
    
    const [filters, setFilters] = React.useState([]);

    return (
        <div className='pageWrapper'>
            <InfoMessage />
            <div className='horizontalContainer'>
                <div className={`${styles.colorSquarePanel} ${styles.yellow}`}>
                    <h1 className={styles.mainHeadline}>Заявки</h1>
                    <h2 className={styles.primaryHeadline}>{loading ? <LoadingBlock width="60px" height="28px" /> : formatNull(formInfo.count_applications)}</h2>
                    <p>Из них:</p>
                    <div 
                        className='buttonWithArrowRight nonActive'
                    >
                        <p>По {formatNull(formInfo.count_applications_with_mailing_status)} проведена рассылка</p>
                    </div>
                    <div 
                        className='buttonWithArrowRight'
                        onClick={() => {
                            const newFilters = {
                                mailing_status: 'Письма отправлены'
                            };
                            setFilters(newFilters);
                            localStorage.setItem(STORAGE_KEY, JSON.stringify(newFilters));
                            navigate('/proposed-cases');
                        }}
                    >
                        <p>По {formatNull(formInfo.count_applications_with_wait_for_attach_am)} ожидается согласие от управляющих</p>
                        <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(255, 153, 11)' className = '' />
                    </div>
                    <div 
                        className='buttonWithArrowRight'
                        onClick={() => {
                            const newFilters = {
                                mailing_status: 'Кандидатура выбрана'
                            };
                            setFilters(newFilters);
                            localStorage.setItem(STORAGE_KEY, JSON.stringify(newFilters));
                            navigate('/proposed-cases');
                        }}
                    >
                        <p>{formatNull(formInfo.count_applications_with_am)} карточек с прикрепленными управляющими</p>
                        <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(255, 153, 11)' className = '' />
                    </div>
                </div>
                <div className={`${styles.colorSquarePanel} ${styles.blue}`}>
                    <h1 className={styles.mainHeadline}>Процедуры</h1>
                    <h2 className={styles.primaryHeadline}>{loading ? <LoadingBlock width="60px" height="28px" /> : formatNull(formInfo.count_cases)}</h2>
                    <p>Из них:</p>
                    <div className='buttonWithArrowRight nonActive'>
                        <p>{formatNull(formInfo.count_active_cases)} активных процедур (со статусом "В работе")</p>
                        {/* <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(68, 74, 255)' className = '' /> */}
                    </div>
                    <div className='buttonWithArrowRight nonActive'>
                        <p>{formatNull(formInfo.count_no_manager_has_been_appointed)} со статусом "Управляющий не назначен"</p>
                        {/* <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(68, 74, 255)' className = '' /> */}
                    </div>
                    <div className='buttonWithArrowRight nonActive'>
                        <p>{formatNull(formInfo.count_completed_cases)} завершенных процедур</p>
                        {/* <IconContainer Icon={ArrowRight} isClickable={false} onClick={() => {}} size = '16' color = 'rgb(68, 74, 255)' className = '' /> */}
                    </div>
                </div>
            </div>
            <div className='horizontalContainer'>
                <div className='homePanel'>
                    {warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} />
                    :
                    <>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="m23.553,22.139l-2.666-2.666c.698-.981,1.113-2.177,1.113-3.473,0-3.314-2.686-6-6-6s-6,2.686-6,6,2.686,6,6,6c1.296,0,2.492-.415,3.473-1.113l2.666,2.666c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414Zm-8.226-3.142c-.601,0-1.204-.225-1.664-.674l-1.132-1.108c-.395-.387-.401-1.02-.015-1.414.386-.395,1.019-.401,1.414-.016l1.132,1.108c.144.142.379.141.522,0l2.713-2.624c.398-.381,1.032-.37,1.414.029.383.398.37,1.031-.029,1.414l-2.703,2.614c-.452.446-1.052.671-1.653.671Zm-7.327-2.997c0-4.411,3.589-8,8-8,1.458,0,2.822.398,4,1.083v-4.083c0-2.757-2.244-5-5-5H4.999C2.242,0,0,2.244,0,5.001v13.999c0,2.757,2.244,5,5,5h11c-4.411,0-8-3.589-8-8Zm2-11h5c.552,0,1,.447,1,1s-.448,1-1,1h-5c-.552,0-1-.447-1-1s.448-1,1-1Zm-4,12h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Zm0-5h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Zm0-5h-1c-.552,0-1-.447-1-1s.448-1,1-1h1c.552,0,1,.447,1,1s-.448,1-1,1Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Непроверенные отчеты</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_unchecked_reports > 0 && 'colorCell red'}`}>Найдено {formInfo.count_unchecked_reports}</a>}
                            <Link 
                                className='aWithLink' 
                                to={`/procedures?section=unconfirmed-reports`}
                            >
                                Перейти во вкладку "Непроверенные отчеты"
                            </Link>
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg id="Layer_1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path fill='currentColor' d="m11 0c-6.075 0-11 4.925-11 11 0 5.447 3.964 9.958 9.162 10.834.068-.445.218-.883.456-1.291l4.808-8.242c.658-1.127 1.83-1.801 3.135-1.801s2.477.673 3.135 1.801l.914 1.567c.247-.916.391-1.874.391-2.867-.001-6.076-4.926-11.001-11.001-11.001zm1 11c0 .552-.447 1-1 1h-4c-.553 0-1-.448-1-1s.447-1 1-1h3v-4c0-.552.447-1 1-1s1 .448 1 1zm4.154 2.308-4.808 8.242c-.633 1.086.15 2.45 1.407 2.45h9.616c1.257 0 2.041-1.364 1.407-2.45l-4.808-8.242c-.629-1.078-2.186-1.078-2.814 0zm1.407 9.692c-.552 0-1-.448-1-1 0-.552.448-1 1-1 .552 0 1 .448 1 1 0 .552-.448 1-1 1zm-1-4v-2.002c0-.552.448-1 1-1 .552 0 1 .448 1 1v2.002c0 .552-.448 1-1 1-.552 0-1-.448-1-1z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Дела с непредставленным в срок отчётом</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_overdue_cases > 0 && 'colorCell red'}`}>Найдено {formInfo.count_overdue_cases ?? '0'}</a>}
                            <Link 
                                className='aWithLink' 
                                to={`/procedures?section=overdue-procedures`}
                            >
                                Перейти во вкладку "Дела с непредставленным в срок отчётом"
                            </Link>
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="M21,6H5c-.859,0-1.672-.372-2.235-.999,.55-.614,1.349-1.001,2.235-1.001H23c1.308-.006,1.307-1.995,0-2H5C2.239,2,0,4.239,0,7v10c0,2.761,2.239,5,5,5H21c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3Zm-1,9c-1.308-.006-1.308-1.994,0-2,1.308,.006,1.308,1.994,0,2Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Арбитражные управляющие с отрицательным балансом по членским взносам</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_negative_balance > 0 && 'colorCell red'}`}>Найдено {formInfo.count_negative_balance}</a>}
                            <Link 
                                className='aWithLink' 
                                to={`/membership-fees`}
                            >
                                Перейти во вкладку "Управляющие с отрицательным балансом"
                            </Link>
                        </div>
                    </div>
                    </>}
                </div>
                <div className='homePanel'>
                    {warning ? <WarningPanel text={warning} buttonText='Обновить' buttonAction={() => setReload(true)} />
                    :
                    <>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="M10,18c0,.339,.028,.672,.069,1h-2.294l-4.479,2.669c-.634,.425-1.483,.445-2.162,.08-.7-.375-1.135-1.1-1.135-1.894V5C0,2.243,2.243,0,5,0h12c2.757,0,5,2.243,5,5v6.082c-1.178-.684-2.542-1.082-4-1.082-4.411,0-8,3.589-8,8Zm14,0c0,3.314-2.686,6-6,6s-6-2.686-6-6,2.686-6,6-6,6,2.686,6,6Zm-2,0c0-.553-.448-1-1-1h-3v-1.121c0-.355-.213-.676-.541-.812-.325-.135-.705-.062-.957,.19l-1.5,1.5c-.685,.685-.685,1.8,0,2.485l1.5,1.5c.251,.252,.629,.329,.957,.19,.328-.136,.541-.456,.541-.812v-1.121h3c.552,0,1-.447,1-1Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Записей об административной ответственности за квартал</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_administrative_quarter > 0 && 'colorCell blue'}`}>Найдено {formInfo.count_administrative_quarter}</a>}
                            {/* <a className='aWithLink' onClick={() => navigate(`/account/${userId}?section=administrative-responsibility`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Административная ответственность"</a> */}
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24"><path fill='currentColor' d="M12,24A12,12,0,1,0,0,12,12.013,12.013,0,0,0,12,24ZM12,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12,5Zm-1,5h1a2,2,0,0,1,2,2v6a1,1,0,0,1-2,0V12H11a1,1,0,0,1,0-2Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Записей дисциплинарного комитета за квартал</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" />  : <a className={`${formInfo.count_disciplinaries_quarter > 0 && 'colorCell blue'}`}>Найдено {formInfo.count_disciplinaries_quarter}</a>}
                            {/* <a className='aWithLink' onClick={() => navigate(`/account/${userId}?section=disciplinary-committee`, { state: { from: location.pathname + location.search + location.hash }})}>Перейти во вкладку "Дисциплинарный комитет"</a> */}
                        </div>
                    </div>
                    <div className='panelInner'>
                        <div className='image'>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24"><path fill='currentColor' d="M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16ZM5.683,16H1a1,1,0,0,1-1-1A6.022,6.022,0,0,1,5.131,9.084a1,1,0,0,1,1.1,1.266A6.009,6.009,0,0,0,6,12a5.937,5.937,0,0,0,.586,2.57,1,1,0,0,1-.9,1.43ZM17,24H7a1,1,0,0,1-1-1,6,6,0,0,1,12,0A1,1,0,0,1,17,24ZM18,8a4,4,0,1,1,4-4A4,4,0,0,1,18,8ZM6,8a4,4,0,1,1,4-4A4,4,0,0,1,6,8Zm17,8H18.317a1,1,0,0,1-.9-1.43A5.937,5.937,0,0,0,18,12a6.009,6.009,0,0,0-.236-1.65,1,1,0,0,1,1.105-1.266A6.022,6.022,0,0,1,24,15,1,1,0,0,1,23,16Z"/></svg>
                        </div>
                        <div className='data'>
                            <h4>Новые учетные записи, ожидающие проверки СРО</h4>
                            {loading ? <LoadingBlock width="100px" height="20px" /> : <a className={`${formInfo.count_users_pending > 0 && 'colorCell blue'}`}>Найдено {formInfo.count_users_pending}</a>}
                            <Link 
                                className='aWithLink' 
                                to={`/users`}
                            >
                                Перейти во вкладку "Пользователи"
                            </Link>
                        </div>
                    </div>
                    </>}
                </div>
            </div>
            {/* <div className='horizontalContainer'>
                <div className='panel linksPanel'>
                    <h3>Новостная лента</h3>
                    <NewsBlock />
                </div>
            </div> */}
        </div>
    )
}

export default WorkerHome;